import { ExportForm } from './components/ExportForm';
import { ExportList } from './components/ExportList';

import { Card, CardContent } from '@/components/ui/Card';

export function AdminVoiceToneExports() {
  return (
    <Card className="min-h-screen rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900">
              Voice Tone Exports
            </h1>
            <p className="mt-1 text-gray-600">
              Create and track exports responsible for generating training files
            </p>
          </div>
        </div>
        <div className="rounded-lg bg-gray-50">
          <div className="container mx-auto space-y-6 px-4 py-6">
            <ExportForm />
            <ExportList />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
